import React, { RefObject } from 'react';
import { Link } from 'gatsby';

import { Button } from '../../../../../packages/ui-components/shadcn/Button';

interface SanityMediaAsset {
  _id: string;
}

interface BackgroundImage {
  asset: SanityMediaAsset;
  hotspot: {
    x: number;
    y: number;
  };
  crop: {
    bottom: number;
    left: number;
    right: number;
    top: number;
  };
  alt?: string;
}

interface MarketingContentSection {
  _key: string;
  label: string;
  desktopBackground: BackgroundImage;
  mobileBackground: BackgroundImage;
  content: {
    blocks: [any];
  };
}

interface SectionNavProps {
  blobNavActive: boolean;
  navRef: RefObject<HTMLDivElement>;
  marketingContentSections: [MarketingContentSection];
  activeSlide: number;
  handleSectionClick: (index: number) => void;
  setNavRef: (el: any, index: number) => void;
  nonTransactionalCTA: {
    linkType?: string;
    internalLink?: { slug: { current: string }; title: string };
    href?: string;
    caption?: string;
  };
}

const SectionNav: React.FC<SectionNavProps> = ({
  blobNavActive,
  navRef,
  marketingContentSections,
  activeSlide,
  handleSectionClick,
  setNavRef,
  nonTransactionalCTA,
}) => (
  <div
    className={`fixed ${
      blobNavActive ? 'top-8 opacity-100' : '-top-20 opacity-25'
    } left-0 right-0 bg-background lg:sticky lg:top-8 lg:opacity-100 lg:block z-10 shadow-lg transition-all duration-300 ease-in-out`}
  >
    <div className="max-w-screen-xl mx-auto h-20">
      <div className="flex justify-between items-center h-full p-4">
        <div
          className="flex gap-2 overflow-x-auto scrollbar-hidden p-2"
          ref={navRef}
        >
          {marketingContentSections?.map((section, index) => (
            <Button
              variant="ghost"
              type="button"
              key={section.label}
              className={`${activeSlide === index && 'bg-accent'}`}
              onClick={() => {
                handleSectionClick(index);
              }}
              ref={el => {
                setNavRef(el, index);
              }}
            >
              <span className="lg:text-lg whitespace-nowrap">
                {section.label}
              </span>
            </Button>
          ))}
        </div>
        <Button asChild className="hidden lg:block lg:ml-4">
          <Link
            to={
              nonTransactionalCTA?.linkType === 'internal'
                ? `/${nonTransactionalCTA?.internalLink?.slug?.current}`
                : nonTransactionalCTA?.href
            }
            className="text-cta-foreground no-underline leading-normal"
          >
            {nonTransactionalCTA?.caption ||
              nonTransactionalCTA?.internalLink.title}
          </Link>
        </Button>
      </div>
    </div>
  </div>
);

export default SectionNav;
